import React, { useEffect, useRef, useState } from "react";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import { history } from "../../_helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  authActions,
  inmateAction,
  eCardAction,
  masterActions,
  publicUserActions,
} from "../../_store";
import { fDate, MinDate, Today } from "../../utils/formatTime";
import CustomLoader from "../../components/common/ui/Loader";
import Swal from "sweetalert2";
import ReadIcon from "../../assets/svg/read-tick.svg";
import UnReadIcon from "../../assets/svg/unread-star.svg";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import generateXlsx from "../../components/common/export/generateXlsx";

function SentECardList() {
  let sorting = false;
  const paginationTriggered = useRef(false);
  const dispatch = useDispatch();

  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );

  const [showSearchFields, setShowSearchFields] = useState(false);
  const EcardReadStatus = useSelector(
    (x) => x?.dropdownOptions?.EcardReadStatus
  );
  const userAccessPermission = useSelector(
    (state) => state.auth.managementUserAccessPermission
  );
  const user = useSelector((x) => x.auth.user);

  const { sentEcardSearchData, getSentEcardListResponse, loading } =
    useSelector((x) => x?.ecard);



  /* Facility Drop down */
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, []);


  /* sent e-card list */
  useEffect(() => {
    if (commonFacilityCode === 0) return;
    const searchData = { ...sentEcardSearchData };
    searchData.FacilityID = commonFacilityCode;
    searchData.PageNo = 1;
    searchData.RowCountPerPage = 10;
    dispatch(eCardAction?.updateSentEcardSearch(searchData));
    dispatch(eCardAction?.getSentEcardList(searchData));
  }, [isPageReloading, commonFacilityCode]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
      .format(date)
      .replace(",", "");
  };

  const findGraphemeClusters = (input, returninput) => {
    const segmenter = new Intl.Segmenter("en", { granularity: "grapheme" });
    if (returninput)
      return (
        Array.from(segmenter.segment(input))
          .slice(0, 15)
          .map((item) => item.segment)
          .join("") + "..."
      );
    else return Array.from(segmenter.segment(input));
  };

  const columns = [
    {
      width: "210px",
      name: "Subject",
      key: "EcardSubject",
      selector: (row) => row.EcardSubject,
      cell: (row) => (
        <div className="d-flex flex-wrap gap-2 align-items-start">
          <div
            title={row.EcardSubject}
            onClick={() => navigateToEcardInfo(row.CardId)}
            className={"Common_Link_Style"}
          >
            {findGraphemeClusters(row.EcardSubject, false)?.length > 15
              ? findGraphemeClusters(row.EcardSubject, true)
              : row.EcardSubject}
          </div>
          {row?.UserPhotoReadStatus === 0 && (
            <div className="newbutton-container">
              New
              <div className="border-animation"></div>
            </div>
          )}
        </div>
      ),
      sortable: true,
    },
    {
      width: "210px",
      name: "From",
      key: "EcardFrom",
      selector: (row) => row.EcardFrom,
      cell: (row) => (
        <div className="d-flex  gap-2 align-items-center">
          {/* <div className="user-batch button-success"></div> */}
          <div
            className={
              row?.Sender === "Public User"
                ? "user-batch button-success"
                : "user-batch button-primary"
            }
          ></div>
          <div
            className="Common_Link_Style"
            onClick={() => {
              if (row?.Sender === "Public User") {
                handleNavigatePublicInfo(row);
                return;
              } else {
                handleNavigateInmateInfo(row);
              }
            }}
          >
            {row.EcardFrom}
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      width: "210px",
      name: "To",
      key: "EcardTo",
      selector: (row) => row.EcardTo,
      sortable: true,
      cell: (row) => (
        <div className="d-flex  gap-2 align-items-center">
          <div
            className={
              row?.Sender === "Inmate"
                ? "user-batch button-success"
                : "user-batch button-primary"
            }
          ></div>
          <div
            className="Common_Link_Style"
            onClick={() => {
              if (row?.Receiver === "Inmate") {
                handleNavigateInmateInfo(row);
                return;
              } else {
                handleNavigatePublicInfo(row);
              }
            }}
          >
            {row.EcardTo}
          </div>
        </div>
      ),
    },

    {
      width: "120px",
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row.InmateResidentId,
      sortable: true,
      cell: (row) => (
        <div
          className="Common_Link_Style"
          onClick={() => handleNavigateInmateInfoID(row)}
        >
          {row.InmateResidentId}
        </div>
      ),
    },

    {
      width: "170px",
      name: "E-Card Cost($)",
      key: "EcardCost",
      selector: (row) => row.EcardCost?.toFixed(2),
      sortable: true,
    },
    {
      width: "180px",
      name: "Sent On",
      key: "Sentdate",
      selector: (row) => row.Sentdate,
      cell: (row) => (
        <div className="d-flex flex-wrap ">
          <div className="font-size-13 fw-500 ">
            {formatDate(row?.Sentdate)}
          </div>
        </div>
      ),
      sortable: true,
    },

    {
      width: "90px",
      name: "E-Card Status",
      key: "ReadStaus",
      selector: (row) => row.ReadStaus,
      cell: (row) =>
        row.ReadStaus === "Read" ? (
          <span
            style={{ marginleft: "10px" }}
            title="This e-card has been opened and read by the recipient."
            className="ecard-read"
          >
            <img src={ReadIcon} alt="read-icon" />
            <span> Read</span>
          </span>
        ) : (
          <span
            style={{ marginleft: "10px" }}
            title="This e-card has not yet been opened by the recipient."
            className="ecard-unread"
          >
            <img src={UnReadIcon} alt="read-icon" />
            <span> Unread</span>
          </span>
        ),
      sortable: true,
      sortFunction: (rowA, rowB) => {
        // Ensuring case-insensitive sorting
        const statusA = rowA.ReadStaus.toLowerCase();
        const statusB = rowB.ReadStaus.toLowerCase();

        if (statusA < statusB) {
          return -1;
        }
        if (statusA > statusB) {
          return 1;
        }
        return 0;
      },
    },
  ];

  const navigateToEcardInfo = (id) => {
    Swal?.close();
    dispatch(eCardAction?.resetForm());
    history.navigate("/Admin/E-Cards/Sent/Details", {
      state: { ecardID: id, source: "ecard" },
    });
  };

  const handleNavigatePublicInfo = (row) => {
    Swal?.close();
    history.navigate("PublicUserList/Details", {
      state: { row: row, source: "ecard" },
    });
    dispatch(publicUserActions?.setPublicUserTab("publicuser-info-tab"));
  };

  const handleNavigateInmateInfo = (row) => {
    Swal?.close();
    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));

    history.navigate("InmateList/Details", {
      state: { inmate: row, source: "ecard", showTransactionTab: false },
    });
  };

  const handleNavigateInmateInfoID = (row) => {
    Swal?.close();
    dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));

    history.navigate("InmateList/Details", {
      state: { inmate: row, source: "ecard", showTransactionTab: false },
    });
  };

  const handleRowPerPage = (page) => {
    const updateSearch = { ...sentEcardSearchData };
    updateSearch.RowCountPerPage = page;
    updateSearch.PageNo = 1;
    updateSearch.FacilityID = commonFacilityCode;
    dispatch(eCardAction?.updateSentEcardSearch(updateSearch));
    dispatch(eCardAction?.getSentEcardList(updateSearch));
  };

  const handlePageChange = (page) => {
    if (sorting) {
      sorting = false;
      return;
    }
    if (paginationTriggered.current) {
      paginationTriggered.current = false;
      return;
    }
    const updateSearch = { ...sentEcardSearchData };
    updateSearch.PageNo = page;
    updateSearch.FacilityID = commonFacilityCode;
    dispatch(eCardAction?.updateSentEcardSearch(updateSearch));
    dispatch(eCardAction?.getSentEcardList(updateSearch));
  };

  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...sentEcardSearchData };
    const newSortOrder = search.SortBy?.includes(column.key)
      ? search.SortBy.endsWith("ASC")
        ? "DESC"
        : "ASC"
      : "ASC";
    search.SortBy = `${column.key} ${newSortOrder}`;
    search.FacilityID = commonFacilityCode;
    dispatch(eCardAction?.updateSentEcardSearch(search));
    dispatch(eCardAction?.getSentEcardList({
      ...sentEcardSearchData,
      SortBy: `${column.key} ${newSortOrder}`,
    }));
  };

  const handleChange = (e, input) => {
    paginationTriggered.current = true;
    const updateSearch = {
      ...sentEcardSearchData,
      FacilityID: commonFacilityCode,
    };

    if (input) {
      if (input === "EcardReadStatus") {
        updateSearch[input] = e?.value !== undefined ? e?.value : 0;
        updateSearch.PageNo = 1;
        updateSearch.RowCountPerPage = 10;
        dispatch(eCardAction?.getSentEcardList(updateSearch));
        dispatch(eCardAction?.updateSentEcardSearch(updateSearch));
        return;
      } else {
        let formattedDate = fDate(e);
        updateSearch[input] = formattedDate;
        updateSearch.PageNo = 1;
        updateSearch.RowCountPerPage = 10;
        dispatch(eCardAction?.updateSentEcardSearch(updateSearch));
      }
      return;
    }
    const { name, value } = e?.target;
    if (name === "InmateResidentId") {
      const regex = /^[0-9\s]*$/;
      if (!regex.test(value)) return;
    }
    updateSearch[name] = value;
    dispatch(eCardAction?.updateSentEcardSearch(updateSearch));
  };

  const handleDateEnterKey = (event, name) => {
    const updateSearch = {
      ...sentEcardSearchData,
    };
    if (event.key === "Enter" && updateSearch[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "EcardSendStartDate") {
      if (
        sentEcardSearchData.EcardSendStartDate &&
        new Date(value) > new Date(sentEcardSearchData.EcardSendEndDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "EcardSendEndDate") {
      if (
        sentEcardSearchData.EcardSendStartDate &&
        new Date(value) < new Date(sentEcardSearchData.EcardSendStartDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...sentEcardSearchData,
      EcardSendStartDate:
        fieldName === "EcardSendStartDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : sentEcardSearchData.EcardSendStartDate, // preserve existing value
      EcardSendEndDate:
        fieldName === "EcardSendEndDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : sentEcardSearchData.EcardSendEndDate, // preserve existing value
    };
    dispatch(eCardAction?.updateSentEcardSearch(updatedParam));
  };

  const handleSearchReset = () => {
    paginationTriggered.current = false;
    const resetSearch = {
      FacilityID: commonFacilityCode,
      InmateResidentId: "",
      PublicFirstName: "",
      PublicLastName: "",
      InmateFirstName: "",
      InmateLastName: "",
      EcardSubject: "",
      EcardSendStartDate: "",
      EcardSendEndDate: "",
      EcardReadStatus: 0,
      PageNo: 1,
      RowCountPerPage: 10,
      SortBy: "",
    };
    dispatch(eCardAction?.updateSentEcardSearch(resetSearch));
    dispatch(eCardAction?.getSentEcardList(resetSearch));
  };

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    const search = {
      ...sentEcardSearchData,
      PageNo: 1,
      RowCountPerPage: 10,
      FacilityID: commonFacilityCode,
    };
    dispatch(eCardAction.updateSentEcardSearch(search));
    dispatch(eCardAction?.getSentEcardList(search));
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form onSubmit={(e) => handleSearchSubmit(e)}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateResidentId"
                id="InmateResidentId"
                label="Inmate ID"
                value={sentEcardSearchData?.InmateResidentId}
                handleChange={(e) => handleChange(e)}
                placeholder="Enter Inmate ID"
                maxLength={18}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateLastName"
                id="InmateLastName"
                label="Inmate Last Name"
                value={sentEcardSearchData?.InmateLastName}
                handleChange={(e) => handleChange(e)}
                placeholder="Enter Last Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateFirstName"
                id="InmateFirstName"
                label="Inmate First Name"
                value={sentEcardSearchData?.InmateFirstName}
                handleChange={(e) => handleChange(e)}
                placeholder="Enter First Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="EcardSubject"
                id="EcardSubject"
                label="Subject"
                value={sentEcardSearchData?.EcardSubject}
                handleChange={(e) => handleChange(e)}
                placeholder="Enter Subject"
              // maxLength={25}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="PublicLastName"
                id="PublicLastName"
                label="Public User Last Name"
                value={sentEcardSearchData?.PublicLastName}
                handleChange={(e) => handleChange(e)}
                placeholder="Enter Last Name"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="PublicFirstName"
                id="PublicFirstName"
                label="Public User First Name"
                value={sentEcardSearchData?.PublicFirstName}
                handleChange={(e) => handleChange(e)}
                placeholder="Enter First Name"
                required={false}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                name="EcardSendStartDate"
                label="From Date"
                value={sentEcardSearchData?.EcardSendStartDate}
                handleChange={(e) => handleChange(e, "EcardSendStartDate")}
                maxDate={
                  sentEcardSearchData?.EcardSendEndDate
                    ? sentEcardSearchData?.EcardSendEndDate
                    : new Date()
                }
                minDate={new Date(2017, 0, 1)}
                //isClearable={false}
                isClearable={
                  sentEcardSearchData?.EcardSendStartDate !== null &&
                  sentEcardSearchData?.EcardSendStartDate !== ""
                }
                preventClear={false}
                handleBlur={(e) => handleDateBlur(e, "EcardSendStartDate")}
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "EcardSendStartDate")
                }
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                name="EcardSendEndDate"
                label="To Date"
                value={sentEcardSearchData?.EcardSendEndDate}
                handleChange={(e) => handleChange(e, "EcardSendEndDate")}
                minDate={
                  sentEcardSearchData?.EcardSendStartDate ||
                  new Date(2017, 0, 1)
                }
                maxDate={new Date()}
                // isClearable={false}
                isClearable={
                  sentEcardSearchData?.EcardSendEndDate !== null &&
                  sentEcardSearchData?.EcardSendEndDate !== ""
                }
                preventClear={false}
                handleBlur={(e) => handleDateBlur(e, "EcardSendEndDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "EcardSendEndDate")}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="EcardReadStatus"
                options={EcardReadStatus}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={sentEcardSearchData?.EcardReadStatus !== 0}
                label="Status"
                placeholder="Select Status"
                value={sentEcardSearchData?.EcardReadStatus}
                handleChange={(e) => handleChange(e, "EcardReadStatus")}
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />

          <Button
            variant="secondary"
            className="me-2"
            onClick={handleSearchReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  if (loading) return <CustomLoader />;

  const handleExcel = () => {
    let updatedParam = {
      ...sentEcardSearchData,
      PageNo: 1,
      exportExcel: true,
      RowCountPerPage: getSentEcardListResponse?.TotalECardCount,
    };
    dispatch(eCardAction.getSentEcardList(updatedParam)).then((x) => {
      let title = "E-Card_List";
      let generateExcelColumns = [
        "Subject",
        "From",
        "To",
        "E-Card Cost($)",
        "Sent On",
        "Status",
      ];

      // Map the account manager list to match the Excel format
      let PUPhoto_List =
        x?.payload?.DataList?.map((obj) => ({
          Subject: obj.EcardSubject,
          From: obj.EcardFrom,
          To: obj.EcardTo,
          Cost: obj.EcardCost.toFixed(2),
          Sent: formatDate(obj.Sentdate),
          Status: obj.ReadStaus,
        })) || [];

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(PUPhoto_List, generateExcelColumns, title);
      } catch (error) {
        // Handle any errors that occur during Excel generation
        showToastNotification("error", "error");
      }
    })
  };

  return (
    <>
      {commonFacilityCode > 0 ? (
        <div className="sent-E-Card">
          <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
            <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
              {/* Mobile only (Below md breakpoint) */}
              <div className=" d-block d-md-none">
                <div
                  className=" d-flex align-items-center justify-content-between"
                  style={{ background: "transparent", cursor: "pointer" }}
                  onClick={toggleInformation}
                >
                  <h2 className="form_title_uppercase text-color">
                    E-CARD HISTORY SEARCH
                  </h2>
                  <i
                    id="itagInformation"
                    className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                      }`}
                    style={{ fontSize: "20px" }}
                  ></i>
                </div>
              </div>
              {/* Mobile only (Below md breakpoint) */}
              <div className="d-block d-md-none mt-2">
                {showSearchFields && renderSearch()}
              </div>

              {/* Web only (Desktop and above) */}
              <div className="mb-3 d-none d-md-block">
                <h2 className="form_title_uppercase text-color">
                  E-CARD HISTORY SEARCH
                </h2>
              </div>
              {/* Web only (Desktop and above) */}
              <div className="d-none d-md-block">{renderSearch()}</div>
            </div>

            <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
              <div className="d-flex flex-wrap justify-content-between align-items-center ">
                <h2 className="text-color">E-CARDS HISTORY LIST</h2>
                <div className="d-flex flex-wrap  justify-content-end">
                  {getSentEcardListResponse?.DataList?.length > 0 && (
                    <ExcelExport variant="soft-gray" handleExcelExport={handleExcel} />
                  )}
                </div>
              </div>

              {getSentEcardListResponse?.DataList?.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mt-1">
                  <div className="d-flex flex-wrap align-items-center gap-1">
                    <div className="user-batch button-success"></div>
                    <div className="text fs-5">Public Users</div>
                  </div>

                  <div className="d-flex flex-wrap align-items-center gap-1">
                    <div className="user-batch button-primary"></div>
                    <div className="text fs-5">Inmates</div>
                  </div>
                </div>
              )}


              <Table
                columns={columns}
                data={getSentEcardListResponse?.DataList}
                pagination
                onChangeRowsPerPage={handleRowPerPage}
                onChangePage={handlePageChange}
                totalRowCount={getSentEcardListResponse?.TotalECardCount}
                currentPage={sentEcardSearchData?.PageNo}
                paginationPerPage={sentEcardSearchData.RowCountPerPage}
                onSort={handleSort}
                serverSideSort
                sortColumn={sentEcardSearchData?.SortBy?.split(" ")[0]}
                sortDirection={sentEcardSearchData?.SortBy?.split(" ")[1]}
              />
            </div>
          </div>
        </div>
      ) : (
        <h4 className="facility-card">Select a Facility Code from the list</h4>
      )}
    </>
  );
}

export default React.memo(SentECardList);
